import { render, staticRenderFns } from "./bottomCart.vue?vue&type=template&id=071860d6&"
import script from "./bottomCart.vue?vue&type=script&lang=js&"
export * from "./bottomCart.vue?vue&type=script&lang=js&"
import style0 from "./bottomCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports